/**
 * 隐私政策页 - 含 WhatsApp、企业微信、Google 日历等说明
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Typography } from 'antd';
import './LandingPage.css';

const { Header, Content, Footer } = Layout;
const { Title, Paragraph } = Typography;

const PrivacyPolicy = () => {
  return (
    <Layout className="landing-page">
      <Header className="landing-header">
        <div className="header-inner">
          <span className="footer-copy">blooart CAMPUS · 隐私政策</span>
          <Link to="/" style={{ color: '#595959', textDecoration: 'none' }}>返回首页</Link>
        </div>
      </Header>
      <Content className="landing-body">
        <section className="section">
          <Title level={2} className="section-title">隐私政策</Title>
          <Paragraph className="section-subtitle">
            本隐私政策适用于 blooart CAMPUS 教育管理平台（以下简称「本平台」）。我们仅面向机构/学校及其授权的老师、学生提供服务。
          </Paragraph>

          <Title level={4}>一、我们如何使用 WhatsApp</Title>
          <Paragraph>
            1. 本平台通过对接 <strong>Meta / WhatsApp 云端 API</strong>，用于向<strong>已在机构/学校完成注册且同意接收通知</strong>的老师、学生发送：课程时间、上课链接、课堂变更提醒；作业/考试提醒；与教学活动直接相关的服务通知。
          </Paragraph>
          <Paragraph>
            2. 我们<strong>不会</strong>将 WhatsApp 用于：群发陌生用户营销信息；购买或使用来历不明的号码数据；灰色、欺诈或与教育无关的业务场景。
          </Paragraph>
          <Paragraph>
            3. 发送内容与频率均与教学管理相关，符合 Meta / WhatsApp 商业政策与官网审核要求。
          </Paragraph>

          <Title level={4}>二、我们如何使用企业微信</Title>
          <Paragraph>
            1. 本平台支持通过 <strong>企业微信（WeChat Work）</strong> 向已加入企业/学校组织的成员发送通知，包括：课程排课与变更提醒；上课链接、作业与考试提醒；与教学服务直接相关的系统通知。
          </Paragraph>
          <Paragraph>
            2. 我们仅向机构/学校在企业微信中已授权的成员发送消息，不向企业外部或未授权用户推送。
          </Paragraph>
          <Paragraph>
            3. 企业微信相关配置（如 AgentId、Secret、应用权限）由机构/学校在自身企业微信管理后台配置，本平台不存储企业微信账号密码，仅按授权范围调用发送接口。
          </Paragraph>
          <Paragraph>
            4. 我们不会通过企业微信向用户发送营销、广告或与教育服务无关的内容。
          </Paragraph>

          <Title level={4}>三、我们如何使用 Google 日历</Title>
          <Paragraph>
            1. 本平台支持与 <strong>Google Calendar（Google 日历）</strong> 同步，用于：读取机构/学校授权账户下的日历事件，用于排课展示与冲突检测；将本平台创建的课程、上课时间写入授权 Google 日历，便于用户在多端查看；基于日历事件触发上课提醒（可结合邮件、企业微信、WhatsApp 等通道）。
          </Paragraph>
          <Paragraph>
            2. 我们仅访问您或机构明确授权给本平台的 Google 日历范围（如特定日历 ID），不会访问或同步未授权的日历或账号下其他 Google 数据。
          </Paragraph>
          <Paragraph>
            3. 同步的日历数据（如事件标题、时间、地点、链接）仅在提供排课与提醒服务所必需的范围内处理，我们不会将您的 Google 日历数据用于广告、营销或与教育无关的用途。
          </Paragraph>
          <Paragraph>
            4. 您可随时在 Google 账号或本平台内撤销对 Google 日历的授权，撤销后我们将停止同步并按要求删除相关缓存数据。
          </Paragraph>

          <Title level={4}>四、我们收集的信息</Title>
          <Paragraph>
            为提供上述服务（含 WhatsApp、企业微信、Google 日历等），我们可能会处理以下信息：<strong>账户与身份</strong>（姓名、登录账号、所属机构、班级、角色等）；<strong>联系方式</strong>（手机/WhatsApp 号码、企业微信成员 ID、邮箱）；<strong>教学与排课</strong>（课程名称、排课时间、上课链接、作业/考试安排等）；<strong>日历与通知</strong>（为同步 Google 日历与发送通知所必要的日历 ID、事件信息及发送记录）。上述信息由机构/学校在合法合规前提下采集并录入，或由用户/机构在授权第三方时提供。我们不会主动面向公众收集个人信息。
          </Paragraph>

          <Title level={4}>五、信息的保存与安全</Title>
          <Paragraph>
            1. 机构/学校的数据存储在受保护的服务器中，仅授权账户可访问。
          </Paragraph>
          <Paragraph>
            2. 我们使用 HTTPS 传输、访问控制、敏感配置加密等技术手段保护数据安全。
          </Paragraph>
          <Paragraph>
            3. 除法律法规另有规定外，我们不会将个人信息出售或出租给第三方。
          </Paragraph>
          <Paragraph>
            4. 第三方服务（WhatsApp、企业微信、Google）的数据处理同时受其各自隐私政策约束，建议您查阅 Meta、腾讯、Google 的相关政策。
          </Paragraph>

          <Title level={4}>六、用户的权利</Title>
          <Paragraph>
            如您是本平台中被录入的老师或学生，您可以通过所属机构/学校或本平台提供的联系方式：查询、访问您的基础信息；请求更正错误信息；请求停止通过某一渠道（如 WhatsApp、企业微信、邮件）接收通知（退订）；请求撤销 Google 日历授权或删除相关同步数据。
          </Paragraph>

          <Title level={4}>七、联系我们</Title>
          <Paragraph>
            如果您对本隐私政策或个人信息处理有疑问，可通过官网「联系我们」中提供的联系方式与我们取得联系。本隐私政策会根据法律法规、业务及第三方产品变化进行更新，更新后的版本将在官网公示。
          </Paragraph>
        </section>
      </Content>
      <Footer className="landing-footer">
        <div className="footer-inner">
          <Link to="/">首页</Link>
          <Link to="/terms">服务条款</Link>
          <span className="footer-copy">blooart CAMPUS</span>
        </div>
      </Footer>
    </Layout>
  );
};

export default PrivacyPolicy;
